import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { CommandBarUploaderComponent } from '@components/commandbar/command-bar-uploader.component';
import { CommandBarComponent } from '@components/commandbar/command-bar.component';
import { DeleteComponent } from '@components/delete/delete.component';
import { LoadingComponent } from '@components/loading/loading.component';
import { MenuObjectDialogComponent } from '@components/menu-object/menu-object.component';
import { MenuComponent } from '@components/menu/menu.component';
import { OfflineStatusComponent } from '@components/offline-status/offline-status.component';
import { PrintComponent } from '@components/print/print.component';
import { SearchBoxComponent } from '@components/search/search-box.component';
import { TemplateNameComponent } from '@components/template-name/template-name.component';
import { TopBarComponent } from '@components/top-bar/top-bar.component';
import { UserComponent } from '@components/user/user.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DeletionService } from '@services/deletion/deletion.service';
import { AboutDialogService } from '@services/modal/about-dialog.service';
import { FtOptionHighlightDirective } from '../../directives/option-highlight.directive';
import { FormbirdCommonModule } from '../common/formbird-common.module';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatSliderModule,
    MatIconModule,
    MatTreeModule,
    MatToolbarModule,
    MatMenuModule,
    MatCardModule,
    MatTooltipModule,
    MatDialogModule,
    MatBadgeModule,
    NgSelectModule,
    MatSidenavModule,
    MatDividerModule,
    MatChipsModule,
    DragDropModule,
    MatProgressSpinnerModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    FormbirdCommonModule,
    MatProgressBarModule,
    MatSelectModule,
    MatSlideToggleModule,
    TopBarComponent,
    CommandBarComponent,
    CommandBarUploaderComponent,
    OfflineStatusComponent,
    DeleteComponent,
    PrintComponent,
    SearchBoxComponent,
    MenuComponent,
    UserComponent,
    MenuObjectDialogComponent,
    LoadingComponent,
    TemplateNameComponent,
    FtOptionHighlightDirective,
    A11yModule
  ],
  exports: [
    TopBarComponent
  ],
  providers: [
    AboutDialogService,
    DeletionService
  ]
})
export class TopBarModule { }
